/*
** $Id$
**
** Copyright 2018 Port25 Solutions, Inc.
** All rights reserved.
*/


import React, { Component } from 'react';
import { Button, Collapse, Badge } from 'react-bootstrap';
import PropTypes from 'prop-types';


/**
 * Animates showing or hiding JSX elements.
 */
export default class CollapsibleElement extends Component {
    constructor(props) {
        super(props)
        this.state = {
            isOpen: false
        }
        this.toggle = this.toggle.bind(this)
    }


    static propTypes = {
        label: PropTypes.string.isRequired,
    };


    toggle() {
        this.setState({
            isOpen: !this.state.isOpen
        })
    }


    render() {
        return (
            <div>
                <h4>
                    <Badge variant='secondary' className='collapseBadge'>
                        {this.props.label}
                    </Badge>
                    <Button onClick={ this.toggle } className='collapseButton'>
                        {this.state.isOpen ? 'Hide' : 'Show' }
                    </Button>
                </h4>
                <hr/>
                <Collapse in={this.state.isOpen}>
                    <div>
                        {this.props.children}
                    </div>
                </Collapse>
            </div>
        );
    }
}
